import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import useConstant from "use-constant";
import { debounce } from "lodash";
import { makeStyles } from "@mui/styles";
import { Search } from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
  filter: {
    margin: theme.spacing(1, 3, 1, 0),
    maxHeight: theme.spacing(4),
    background: theme.palette.common.white
  }
}));

const TextFilter = ({
  column: { filterPlaceholder, filterValue = [], setFilter }
}) => {
  const { filter } = useStyles();
  const [textValue, setTextValue] = useState("");
  const debouncedOnChange = useConstant(val =>
    debounce(val => setFilter(val), 500)
  );
  return (
    <TextField
      placeholder={filterPlaceholder}
      fullWidth
      variant="filled"
      value={textValue}
      onChange={e => {
        setTextValue(e.target.value);
        debouncedOnChange(e.target.value);
      }}
      InputProps={{
        disableUnderline: true,
        endAdornment: <Search color="action" />,
        className: filter
      }}
      hiddenLabel
    />
  );
};

export default TextFilter;
